<template>
  <div id="app">
    <div id="header">
    </div>
    <div id="main">
      <h2>Authorize</h2>
      <p>Please insert your Authorization Token and press "Authorize"<br />
        If you do not have a token or it has expired, please request one
      </p>
      <form @submit="submitForm">
        <textarea v-model="fields.textArea" id="token" rows="6" cols="78"></textarea><br />
        <button
          :disabled="saveStatus === 'SAVING' || isTextAreaLimitExceeded || waiting"
          :class="saveStatus === 'SAVING' ? 'ui button' : 'submit'"
        >{{ buttonLabel }}</button>
        <br /><span style="color: red">{{ fieldErrors.textArea }}</span>
        <span v-if="isTextAreaLimitExceeded"
          style="color: red; display: block">
          Must not exceed 500 characters
        </span>
        <span v-if="authorizeFailure"
          style="color: red; display: block">{{ authorizeLastErrorMsg }}</span>
      </form>
      <br />
      <p>If nothing happens when you click the button, make sure Javascript Content is not being blocked on the browser</p>
    </div>
    <div id="footer">
      <div class="ui segment">
        <h4 class="ui header">Logs</h4>
        <ul>
          <div v-if="loading" class="ui active inline loader">Loading...</div>
          <li v-for="item in items" class="item" v-bind:key="item.id">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from './services/apiClient.js'
import axios from 'axios'

function formatTimestamp(date) {
  const d = date;
  const datePart = d.getFullYear()
    + '-' + String(d.getMonth() + 1).padStart(2, '0')
    + '-' + String(d.getDate()).padStart(2, '0');
  const timePart = String(d.getHours()).padStart(2, '0')
    + ':' + String(d.getMinutes()).padStart(2, '0')
    + ':' + String(d.getSeconds()).padStart(2, '0');
  return `${datePart} @ ${timePart}`;
}

export default {
  name: 'App',
  components: {},
  data() {
    return {
      fields: {
        textArea: ''
      },
      fieldErrors: {
        textArea: undefined
      },
      items: [],
      loading: false,
      saveStatus: 'READY',
      authorizeFailure: false,
      authorizeLastErrorMsg: '',
      waiting: false
    }
  },
  methods: {
    async submitForm(evt) {
      evt.preventDefault();
      this.authorizeFailure = false;
      this.fieldErrors = this.validateForm(this.fields);
      if (Object.keys(this.fieldErrors).length) return;

      const authorized = await this.authorizeIP();

      if (authorized) {
        sessionStorage.setItem('textArea', JSON.stringify(this.fields.textArea));
      } else {
        return;
      }

      const slicedItems = this.items.slice(0, 9);
      const items = [...slicedItems];
      this.saveStatus = 'SAVING';
      apiClient.saveItems(items)
        .then(() => {
          this.items = items;
          this.saveStatus = 'SUCCESS';
        })
        .catch((err) => {
          console.log(err);
          this.saveStatus = 'ERROR';
        });
    },
    validateForm(fields) {
      const errors = {};
      if (!fields.textArea) errors.textArea = "A Token is required";
      if (fields.textArea && !this.isJWT(fields.textArea)) {
        errors.textArea = "Invalid or Expired Token";
      }
      return errors;
    },
    isJWT(token) {
      try {
        const parts = token.split('.');
        if (parts.length !== 3) return false;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        const utcNowSec = Math.floor(Date.now() / 1000);
        return payload.exp > utcNowSec;
      } catch(err) {
        console.log(err);
        return false;
      }
    },
    authorizeIP() {
      const baseURI = process.env.VUE_APP_AUTHORIZE_URL;

      this.waiting = true;
      return axios
        .get(baseURI, {
          headers: {
            'Authorization': `${this.fields.textArea}`
          }
        })
        .then(response => {
          this.items.unshift(`${formatTimestamp(new Date())}: [${response.data.Status}] ${response.data.IPAddress} (${response.data.Message})`);
          return true;
        })
        .catch(error => {
          this.authorizeFailure = true;
          this.authorizeLastErrorMsg = 'Authorization failed. Please try again.';
          console.error(error);
          this.items.unshift(`${formatTimestamp(new Date())}: Authorization failed`);
          return false;
        })
        .finally(() => {
          this.waiting = false;
        });
    }
  },
  computed: {
    isTextAreaLimitExceeded() {
      return this.fields.textArea.length >= 500;
    },
    buttonLabel() {
      const labels = {
        SAVING: 'Saving...',
        SUCCESS: 'Authorize Submitted',
        ERROR: 'Authorize Submission failed',
        READY: 'Authorize'
      };
      return labels[this.saveStatus] || 'Authorize';
    }
  },
  created() {
    this.loading = true;
    apiClient.loadItems().then((items) => {
      this.items = items;
      this.loading = false;
    });
  }
}
</script>

<style>
html, body {
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#footer {
  text-align: left;
}
#main {
  margin-top: 100px;
}
</style>
